import WebsiteBehaviors from "../website-behaviors/index.js";
import FrameCommRouter from "../frame-comm-router.js";
import PDF from "../website-behaviors/PDF.js";

const IDENT = "Blackboard";
const PN_BLACKBOARD_PDF_TITLE_REQUEST = "PN_BLACKBOARD_PDF_TITLE_REQUEST";
const PN_BLACKBOARD_PDF_TITLE_RESPONSE = "PN_BLACKBOARD_PDF_TITLE_RESPONSE";
const TOP_FRAME = "top-frame";
const CLASS_FRAME = "class-iframe";
const PDF_FRAME = "pdf-iframe";

// Keep this up here in order to avoid reference issues that would require us to
// do lots of bind() or use arrow functions for class methods (which currently seem
// incompatible with tests in this codebase).
let comm: any;

// This function is only used to check for the CLASS_FRAME,
// but it can be useful for debugging, so I left it in here.
const _identifyFrame = () => {
	const frameElement = window.frameElement;

	let frame = null;
	if (window.self === window.top)
		frame = TOP_FRAME;
	else if (frameElement && (frameElement as any).name === "classic-learn-iframe" && frameElement.hasAttribute("bb-iframe-max-height"))
		frame = CLASS_FRAME;
	else if ((window as any).PDFViewerApplication !== undefined)
		frame = PDF_FRAME;

	return frame;
};

// See also BlackboardPdf class, below!
class Blackboard extends WebsiteBehaviors {
	identifier() {
		return IDENT;
	}

	static isPDF() {
		// inner PDF frame handled by BlackboardPdf class
		return false;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		const frameElement = window.frameElement;

		// There are some other things that seem like they should work to identify
		// the top frame, like:
		//	window.__isUltraApp === true
		// or
		//	document.querySelector("meta[name='author']").content === "Blackboard"
		// but they don't seem to [reliably or maybe at all] exist when this code runs.
		const base = document.querySelector("base");
		const topFrameCase = base?.href.includes("ultra.content.blackboardcdn.com");
		const middleFrameCase = (location.pathname.includes("/webapps/blackboard")
			&& frameElement
			&& (frameElement.hasAttribute("bb-iframe-max-height")
				|| frameElement.hasAttribute("bb-iframe-event-repeater")));
		const pass = topFrameCase ?? middleFrameCase;

		if (pass) // run msg router in all frames, including top level
			comm = new FrameCommRouter(IDENT);

		return pass;
	}

	shouldFrameTakeControl() {
		if (_identifyFrame() === CLASS_FRAME) {
			// @ts-expect-error TS(7006) FIXME: Parameter 'msg' implicitly has an 'any' type.
			comm.registerFrameHandler(CLASS_FRAME, (msg) => {
				// The PDF child frame uses its own url, but gets the page title
				// from its parent iframe (which represents the class context).
				if (msg.type === PN_BLACKBOARD_PDF_TITLE_REQUEST) {
					const pth = document.getElementById("pageTitleHeader");
					const pageTitle = pth ? pth.innerText : document.title;

					comm.send(PDF_FRAME, {
						type: PN_BLACKBOARD_PDF_TITLE_RESPONSE,
						pageTitle
					});
				}
			});
		}

		return true;
	}

	// @ts-expect-error TS(2416) FIXME: Property 'topFrameHandler' in type 'Blackboard' is... Remove this comment to see the full error message
	async topFrameHandler() {
		// Manage pageData (like url) ourselves,
		// since the top-level page url doesn't change for different content.
		return {skipPageData: true};
	}

	// Get citation data from the course frame,
	// not the top-level frame that's just a container.
	structuredCitationFromTopFrame() {
		return false;
	}
}

class BlackboardPdf extends PDF {
	identifier() {
		return "BlackboardPdf";
	}

	static isPDF() {
		return true;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		const pass = location.host.includes("content.blackboardcdn.com");

		if (pass) // run msg router in all frame levels
			comm = new FrameCommRouter(IDENT);

		return pass;
	}

	// shouldFrameTakeControl returns true from PDF parent class.

	async getPageTitle() {
		if ((this as any).pageTitle)
			return (this as any).pageTitle;

		return new Promise((res, rej) => {
			// @ts-expect-error TS(7006) FIXME: Parameter 'msg' implicitly has an 'any' type.
			comm.registerFrameHandler(PDF_FRAME, (msg) => {
				if (msg.type === PN_BLACKBOARD_PDF_TITLE_RESPONSE) {
					(this as any).pageTitle = msg.pageTitle;
					res((this as any).pageTitle);
				}
			});

			// TODO: timeout?
			comm.send(CLASS_FRAME, {type: PN_BLACKBOARD_PDF_TITLE_REQUEST});
		});
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
	async mouseUp(event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy) {
		const selectionMade = await super.mouseUp(event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy);

		if (selectionMade) {
			const pageTitle = await this.getPageTitle();
			page.setPageDataOverride({
				pageUrl: this.getPageUrl(processOrgProxy),
				pageTitle
			});
		}

		return selectionMade;
	}

	// Get citation data from the pdf viewer frame,
	// not the top-level frame that's just a container.
	structuredCitationFromTopFrame() {
		return false;
	}
}

export {Blackboard, BlackboardPdf};
